export default __webpack_public_path__ + "static/media/315.abcc71d1.jpg";